import { observer } from 'mobx-react'
import React from 'react'
import { Button } from 'ui-framework'
import AboutStaking from './AboutStaking'
import Rewards from './Rewards'
import Dao from './Dao'
import StakingForm from './StakingForm'
import StakingVM from './StakingVM'
import WalletUpdate from './WalletUpdate'
import coinsLeftImg from './staking-coins-left.svg'
import coinsRightImg from './staking-coins-right.svg'

export function StakingDashboard({ vm }: { vm: StakingVM }) {
  const { media } = vm.rootStore.uiStore
  const { rewards } = vm.rootStore.stakingStore

  return (
    <section className="staking__wrapper margin-bottom-4">
      <>
        <div className="btn--sticked-horizontal margin-bottom-2">
          <Button
            variant="tab-blue"
            active={vm.section === 'stake'}
            name="section"
            value="stake"
            onClick={vm.set}
            onClickEmit="name-value">
            Staking
          </Button>
          <Button
            notify={rewards.canClaimStakingRewards || rewards.canClaimSushiRewards}
            variant="tab-blue"
            active={vm.section === 'rewards'}
            name="section"
            value="rewards"
            onClick={vm.set}
            onClickEmit="name-value">
            Rewards
          </Button>
          <Button
            variant="tab-blue"
            active={vm.section === 'dao'}
            name="section"
            value="dao"
            onClick={vm.set}
            onClickEmit="name-value">
            DAO
          </Button>
        </div>
        {vm.section === 'stake' && <StakingForm />}
        {vm.section === 'rewards' && <Rewards />}
        {vm.section === 'dao' && <Dao />}
        <WalletUpdate vm={vm} />

        {!media.isMobileMedia && (
          <>
            <img src={coinsLeftImg} className="staking__coins-left-img" />
            <img src={coinsRightImg} className="staking__coins-right-img" />
          </>
        )}
      </>

      <AboutStaking vm={vm} />
    </section>
  )
}

export default observer(StakingDashboard)
